// extracted by mini-css-extract-plugin
export default {"results":"MobileFilterCount-RW971__results","results-text":"MobileFilterCount-LO85o__results-text"};